import styled from 'styled-components';
import * as grid from 'view/styles/grid';

// eslint-disable-next-line rulesdir/no-styled-export
export const LoaderContainer = styled.div`
    margin-top: ${grid.multiple(20).px};
`;
